import axios from "axios";
import api, { refreshApi } from "./api";

let pendingRefresh = null;
let cancelRefresh = null;
let generation = 0;

export const clearSession = () => {
  generation += 1;
  if (cancelRefresh) cancelRefresh.cancel("Session cleared");
  pendingRefresh = null;
  cancelRefresh = null;
  localStorage.removeItem("token");
  delete api.defaults.headers.Authorization;
};

export const refreshSession = () => {
  if (pendingRefresh) return pendingRefresh;
  const currentGeneration = generation;
  cancelRefresh = axios.CancelToken.source();
  pendingRefresh = refreshApi
    .post("/auth/refresh_token", undefined, {
      cancelToken: cancelRefresh.token,
      timeout: 10000,
    })
    .then(({ data }) => {
      if (currentGeneration !== generation)
        throw new Error("ERR_SESSION_CHANGED");
      if (!data?.token) throw new Error("ERR_SESSION_EXPIRED");
      localStorage.setItem("token", JSON.stringify(data.token));
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
      return data;
    })
    .finally(() => {
      if (currentGeneration === generation) {
        pendingRefresh = null;
        cancelRefresh = null;
      }
    });
  return pendingRefresh;
};
